import { createSlice } from '@reduxjs/toolkit';

import { handleGetInquiryStatuses } from './actions';
import { IInquiryStatusesState } from './slice.interface';

const initialState: IInquiryStatusesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const inquiryStatusesSlice = createSlice({
  name: 'inquiry-statuses',
  initialState,
  reducers: {
    removeInquiryStatuses: (state: IInquiryStatusesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetInquiryStatuses.pending, (state: IInquiryStatusesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetInquiryStatuses.rejected, (state: IInquiryStatusesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetInquiryStatuses.fulfilled, (state: IInquiryStatusesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeInquiryStatuses } = inquiryStatusesSlice.actions;

export default inquiryStatusesSlice.reducer;
